import { useEffect, useState, useMemo, useCallback } from "react";
import {Col} from 'reactstrap'
import { useMediaQuery } from 'react-responsive'
import { APILA } from "../../../../../config/apila";
import ReactPaginate from "react-paginate";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import Swal from "sweetalert2";
import swal from "sweetalert";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";
import LoaderHome from "../../../../Loader/LoaderHome";
import { useLocation, useNavigate, Link, useParams} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faMagnifyingGlass,
  faPenToSquare,
  faTrash,
  faListUl
 } from '@fortawesome/free-solid-svg-icons';
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import ToastError from "../../../../NotificationToast/ToastError";
import { PulseLoader } from "react-spinners";
import Pagination from "../../../../components/pagination_new";

export default function SubElements() {
  document.title = "Sub Elements";

  const [getData, setGetData] = useState([]);
  const ascending = 1;
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });

  const [searchKeyword, setSearchKeyword] = useState("");
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isFetching, setIsFetching] = useState(false);
  
  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);

  const [id, setId] = useState();
  const [dataUpdate, setDataUpdate] = useState();

  // ==========================================

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState();
  const [rows, setRows] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [query, setQuery] = useState("");
  const [msg, setMsg] = useState("");

  const {id_element, slug_name} = useParams();

  const [loading, setLoading] = useState(false);

  const [getDescElement, setGetDescElement] = useState([]);
  const [getNumElement, setGetNumElement] = useState([]);
  const [getIdElement, setGetIdElement] = useState([]);

  // ==================================================

  // Filter permission menu
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0
  });

  const navigate = useNavigate();

  useEffect(() => {
    const storageLevel = localStorage.getItem('level');
    const storageItems = JSON.parse(localStorage.getItem('role_permission')) || [];

    if (storageLevel === "developer" || storageLevel === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1
      });
    } else {
      const foundPermission = storageItems.find(
        item => item.menu?.url === location.pathname
      );

      if (!foundPermission) { 
        navigate('/dashboard');
      } else {
        setPermission({
          create: foundPermission.create,
          read: foundPermission.read,
          update: foundPermission.update,
          delete: foundPermission.delete
        });
      }}
  }, [location.pathname, navigate]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  //Get Data Element
  // const GetNamaElement = async () => {
  //   const response = await APILA.get(`/api/elements/${id_element}`,fetchParams)

  //   setGetDescElement(response.data.data.description);
  //   setGetNumElement(response.data.data.name_element);
  //   setGetIdElement(response.data.data.id);
  // }

  const GetNamaElement = useCallback(async () => {
    setIsFetching(true);

    try {
      const response = await APILA.get(
        `/api/elements/${id_element}`,
        fetchParams
      );

      if (response?.status === 200) {
        setGetDescElement(response.data.data.description);
        setGetNumElement(response.data.data.name_element);
        setGetIdElement(response.data.data.id);
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memuat data",
      });
    } finally {
      setIsFetching(false);
    }
  }, [ascending, fetchParams]);


  const GetResponseData = useCallback(async () => {
    setSearchKeyword("");
    setTablePage(1);
    setIsFetching(true);

    try {
      const response = await APILA.get(
        `/api/sub-elements?page=1&limit=1000&ascending=${ascending}&search=${keyword}&id_element=${id_element}`,
        fetchParams
      );

      if (response?.status === 200) {
        setGetData(response?.data?.data || []);
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memuat data",
      });
    } finally {
      setIsFetching(false);
    }
  }, [ascending, fetchParams]);

  useEffect(() => {
    GetResponseData();
    GetNamaElement();
  }, [GetResponseData, GetNamaElement]);


  const deleteById = async (id, name) => {
    Swal.fire({
      title: "Hapus data ini?",
      html: `<p class="sims-delete-description">Data <strong></strong> yang dihapus tidak dapat dikembalikan.</p>`,
      icon: "warning",
      customClass: {
        popup: "sims-delete-popup",
        icon: "sims-delete-icon",
        title: "sims-delete-title",
        actions: "sims-delete-actions",
        confirmButton: "sims-delete-confirm",
        cancelButton: "sims-delete-cancel",
        validationMessage: "sims-delete-validation",
      },
      buttonsStyling: false,
      showCancelButton: true,
      confirmButtonText: "Hapus data",
      cancelButtonText: "Batal",
      reverseButtons: true,
      focusCancel: true,

      didOpen: (popup) => {
        popup.querySelector(".sims-delete-description strong").textContent = name || "indikator";
      },
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          const response = await APILA.delete(
            `/api/sub-elements/${id}`,
            fetchParams
          );
  
          if (response.data.error) {
            throw new Error(response.data.message);
          }
  
          return response;
        } catch (error) {
          Swal.showValidationMessage(
            error.response?.data?.message || "Gagal menghapus data"
          );
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        ToastSuccess.fire({
          icon: "success",
          title: "Data berhasil dihapus",
        });
        GetResponseData();
      }
    });
  };

  const viewModalUpdate = (id, sub) => {
    setModalUpdate(true)
    setId(id)
    setDataUpdate(sub)
  }

  const nameCollator = useMemo(
    () => new Intl.Collator("id", { sensitivity: "base", numeric: true }),
    []
  );

  const filteredData = useMemo(() => {
    const keyword = (searchKeyword || "").trim().toLowerCase();

    const result = !keyword
      ? getData || []
      : (getData || []).filter((item) => {
          const indikatorNama = (item?.description || "")
            .toString()
            .toLowerCase();
          
          return (
            indikatorNama.includes(keyword) 
          );
        });

    return [...result].sort((a, b) =>
      nameCollator.compare(
        (a?.text || "").toString().trim(),
        (b?.text || "").toString().trim()
      )
    );
  }, [getData, searchKeyword, nameCollator]);

  const totalPages = Math.max(1, Math.ceil(filteredData.length / rowsPerPage));

  useEffect(() => {
    setTablePage((page) => Math.min(page, totalPages));
  }, [totalPages]);

  const paginatedData = useMemo(() => {
    const safeRows = Math.max(1, rowsPerPage);
    const start = (tablePage - 1) * safeRows;
    return filteredData.slice(start, start + safeRows);
  }, [filteredData, tablePage, rowsPerPage]);

  
  return (
    <div className="body sims-page" >

      {modalAdd && (
        <ModalAdd
          idelement={getIdElement}
          namaElement = {getDescElement}
          GetResponseData={GetResponseData}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
        />
      )}

      {modalUpdate && (
        <ModalUpdate 
          num_element={getNumElement}
          namaElement = {getDescElement}
          GetResponseData={GetResponseData}
          id={id}
          dataUpdate={dataUpdate}
          show={modalUpdate}
          onHide={() => setModalUpdate(false)}
        />
      )}

      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon icon={faListUl} />
            </span>
            <h4 className="page-title-text">Indikator</h4>
          </div>

          <div className="ml-auto">
            <button
              type="button"
              className="btn btn-create sims-header-button"
              onClick={() => setModalAdd(true)}
            >
              <FontAwesomeIcon icon={faPlus} />
              <span>{isTabletOrMobile ? "Indikator" : "Tambah Indikator"}</span>
            </button>
          </div>
        </div>

        <nav
          aria-label="breadcrumb"
          className="sims-breadcrumb-nav mt-4"
        >
          <ol className="sims-breadcrumb">
            <li className="sims-breadcrumb-item">
              <Link to="/dashboards-la-main">Dashboard</Link>
            </li>

            <li className="sims-breadcrumb-separator">/</li>

            <li
              className="sims-breadcrumb-item active"
              aria-current="page"
            >
              <Link to="/elements">Element</Link>
            </li>

            <li className="sims-breadcrumb-separator">/</li>

            <li
              className="sims-breadcrumb-item active"
              aria-current="page"
            >
              {getNumElement}
            </li>
          </ol>
        </nav>

       
      </div>
      
      <div className="body-content sims-content">
        {isFetching ? (
          <div className="sims-loading">
            <PulseLoader color="#3f5bea" size={12} />
          </div>
        ) : (
          <Col xl="12" sm="12" className="sims-column">
           
            <div className="sims-search-wrap mb-3">
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  className="sims-search-icon"
                />
                <input
                  className="sims-search-input"
                  placeholder="Cari Indikator..."
                  value={searchKeyword}
                  onChange={(event) => {
                    setSearchKeyword(event.target.value);
                    setTablePage(1);
                  }}
                />
            </div>
            
            <div className="assessment-element-info">
              <h5 className="mt-2 mb-2">{getDescElement}</h5>
            </div>

            <div className="sims-table-card">
              <div className="sims-table-scroll">
                <table className="sims-table">
                  <thead>
                    <tr>
                      <th className="sims-col-number">No</th>
                      <th>Indikator</th>
                      <th className="sims-col-action">Aksi</th>
                    </tr>
                  </thead>

                  <tbody>
                    {paginatedData.length > 0 ? (
                      paginatedData.map((row, index) => (
                        <tr key={row?.id || index}>
                          <td className="sims-col-number">
                            <span className="sims-number-badge">
                              {(tablePage - 1) * rowsPerPage + index + 1}
                            </span>
                          </td>

                          <td>
                            <span >
                              {row.description || "-"}
                            </span>
                          </td>

                          <td className="sims-col-action">
                            <div className="sims-action-wrap">
                              <button
                                type="button"
                                className="sims-action-button sims-action-edit"
                                title="Update Data"
                                onClick={() => viewModalUpdate(row?.id, row)}
                              >
                                <FontAwesomeIcon icon={faPenToSquare} />
                              </button>

                              <button
                                type="button"
                                className="sims-action-button sims-action-delete"
                                title="Hapus Indikator"
                                onClick={() => {deleteById(row?.id, row?.description)}}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="sims-empty-state">
                           <div className="module-empty-state-content">
                             Data indikator tidak ditemukan
                           </div>
                         
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <Pagination
                totalRows={filteredData.length}
                tablePage={tablePage}
                rowsPerPage={rowsPerPage}
                onPageChange={setTablePage}
                onRowsPerPageChange={(value) => {
                  setRowsPerPage(value);
                  setTablePage(1);
                }}
              />
            </div>
          </Col>
        )}
      </div>
    </div>
   );



}
